export { default } from "./DecodableFilledIcon";
